export function paramsSpliter(href) {
	let url = decodeURI(href)
	let pramObj = {}
	if (url.indexOf("?") != -1) {
		let temp1 = url.split('?');
		let pram = temp1[1];
		let table = temp1[2] ? temp1[2].split('&') : []
		let keyValue = temp1[2] ? [...pram.split('&'), ...table] : pram.split('&');
		for (let i = 0; i < keyValue.length; i++) {
			let item = keyValue[i].split('=');
			let key = item[0];
			let value = item[1];
			pramObj[key] = decodeURI(value);
		}
		return pramObj
	}
	return {}
}